<template>
  <MediaBlock
    :cols="columns"
    :cols-centered="item.fields.imageCenteredInRow"
    :content-centered="item.fields.imageCentered"
    :media="mediaObject"
    v-bind="
      $ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'image'
      })
    "
  />
</template>

<script setup lang="ts">
import { MediaBlock } from '@hypercodestudio/basler-components';
import type { IImage } from '~~/lib/ContentfulService';
import { generateImageObject } from '~/utils/generateImageObject';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { buildContentImagePreset } from '~/utils/imagePresetRegistry';
const { $ContentfulLivePreview } = useNuxtApp();

type Props = {
  item: IImage;
};

const props = defineProps<Props>();

const columns = computed(
  () => mapColsWidth(props.item.fields.imageWidth ?? '10 cols') ?? 10
);

const imageOptions = computed(() => {
  const preset = buildContentImagePreset(columns.value);

  if (props.item.fields.imageFormat === 'Original') {
    return {
      ...preset,
      originalDimensions: true
    };
  }

  return preset;
});

const mediaObject = computed(
  () => generateImageObject(props.item, imageOptions.value) || null
);
</script>
